// extracted by mini-css-extract-plugin
export var document = "landing-module--document--ebe3b";
export var fullWidth = "landing-module--fullWidth--e9978";